import { render, staticRenderFns } from "./TeacherFundByYearStatistics.vue?vue&type=template&id=6b8ab8d9&scoped=true&"
import script from "./TeacherFundByYearStatistics.vue?vue&type=script&lang=js&"
export * from "./TeacherFundByYearStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8ab8d9",
  null
  
)

export default component.exports